import Component from './ForgotPassword.vue';

export default Component;
